export default __webpack_public_path__ + "static/about-img8-f735fb8c8ccd0ddc53820d175929c55d.png";